export const FLAG_KEYS = {
  DEMO_BANNER: 'demo-banner',
  REDESIGN: 'redesign',
  AI_FEATURES: 'ai-features',
  AI_DIAGNOSE: 'ai-diagnose',
} as const;

export type FlagKey = (typeof FLAG_KEYS)[keyof typeof FLAG_KEYS];
